<template>
  <div class="distance-charity" :class="{'distance-charity_charity': type === 'charity'}">
    <Modal
      :active="active"
      name="DistanceCharityModal"
      :class="{ 'for-mobile-app': isMobileApp }"
      @close.prevent="close"
    >
      <div class="distance-charity__container">
        <div class="distance-charity__tabs" v-if="goal && goal.isCharityGoalEnabled ? goal.isCharityGoalEnabled : false ">
          <Tabs
            :items="tabs"
            :activeItem="selectedTab"
            @changed="onChangeTab"
          />
          <div class="divider"></div>
        </div>
        <div v-if="selectedTab === 0">
          <div v-if="goalsEnable" class="distance-charity__buttons">
            <div @click="setActiveTab('Steps')" class="distance-charity__button" :class="{ active: activeTab === 'Steps' }">Шаги{{  }}</div>
            <div @click="setActiveTab('Trening')" class="distance-charity__button" :class="{ active: activeTab === 'Trening' }">Тренировки</div>
          </div>
          <div>
            <div v-if="activeTab === 'Steps'">
              <p class="distance-charity__title">{{ goalSteps && goalSteps.title ? goalSteps.title : '' }}</p>
              <p class="distance-charity__subtitle" v-html="goalSteps && goalSteps.description ? goalSteps.description : ''"></p>
              <div class="distance-charity__content">
                <Goal
                  v-if="type === 'distance'"
                  :formatTotalKm="formatTotalKmSteps"
                  :formatCurrentKm="formatCurrentKmSteps"
                  :totalKm="goalSteps ? goalSteps.necessaryDistance : 0"
                  :currentKm="goalSteps ? goalSteps.completedDistance : 0"
                  :localizedText="{
                    distance: 'вместе преодолено', total: 'Вместе преодолеть:'
                  }"
                  fullWidth
                  class="distance-charity__goal"
                ></Goal>
                <div v-if="type === 'distance'">
                  <div
                  v-for="(item, i) in completedGoalsSteps"
                  :key="i"
                  class="distance-charity__completed text-center"
                >
                  <div class="distance-charity__status"><Icon name="check-bold" size="l" /></div>
                  <div class="distance-charity__name">{{ item.necessaryDistance ? item.necessaryDistance.toLocaleString() : 0 }} км вместе преодолено</div>
                  <div class="distance-charity__date">{{ formatDate(item.completedOn) }}</div>
                </div>
              </div>
              </div>
            </div>
            <div v-if="activeTab === 'Trening'">
              <p class="distance-charity__title">{{replaceVariables(getTitle())}}</p>
              <p class="distance-charity__subtitle" v-html="replaceVariables(getSubtitle())"></p>
              <div class="distance-charity__content">
                <Goal
                  v-if="type === 'distance'"
                  :formatTotalKm="formatTotalKm"
                  :formatCurrentKm="formatCurrentKm"
                  :totalKm="goal ? goal.necessaryDistance : 0"
                  :currentKm="goal ? goal.completedDistance : 0"
                  :localizedText="{
                    distance: 'вместе преодолено', total: 'Вместе преодолеть:'
                  }"
                  fullWidth
                  class="distance-charity__goal"
                ></Goal>
                <div v-if="type === 'distance'">
                  <div
                  v-for="(item, i) in completedGoals"
                  :key="i"
                  class="distance-charity__completed text-center"
                >
                  <div class="distance-charity__status"><Icon name="check-bold" size="l" /></div>
                  <div class="distance-charity__name">{{ item.necessaryDistance ? item.necessaryDistance.toLocaleString() : 0 }} км вместе преодолено</div>
                  <div class="distance-charity__date">{{ formatDate(item.completedOn) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div v-if="selectedTab === 1">
          <p class="distance-charity__title">{{ goal.costTitle }}</p>
          <p class="distance-charity__subtitle" v-html="goal.costDescription"></p>
          <div class="distance-charity__content">
            <div class="distance-charity__goal">
              <div class="h3">
                <span class="color-success" v-html="goal ? `${goal.completedAmount} ₽` : '0 ₽'"></span> собрано во благо
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import Goal from '@sc-component-library/goal/src/main';
import DistanceImage from '@/assets/img/distance-charity-modal/distance.svg';
import CharityImage from '@/assets/img/distance-charity-modal/charity.svg';
import { formatNumber } from '@/assets/js/helpers';

export default {
  name: 'DistanceCharityModal',
  components: {
    Goal,
  },
  props: {
    active: Boolean,
    type: String,
    localizedText: Object,
    moreLink: String,
    isMobileApp: Boolean,
  },
  data() {
    return {
      distanceImage: DistanceImage,
      charityImage: CharityImage,
      tabs: [
        { title: 'Достичь', enabled: true },
        { title: 'Собрать', enabled: true },
      ],
      selectedTab: 0,
      activeTab: 'Steps',
    };
  },
  computed: {
    ...mapGetters('goals', ['goal', 'goalSteps']),
    goalsEnable() {
      const goalSteps = this.goalSteps ? this.goalSteps : {};
      const goal = this.goal ? this.goal : {};
      return goalSteps?.isPrimaryGoalEnabled && goal?.isPrimaryGoalEnabled;
    },
    goalStepsEnable() {
      const goalSteps = this.goalSteps ? this.goalSteps : {};
      return goalSteps?.isPrimaryGoalEnabled;
    },
    completedGoals() {
      let completedGoals = this.goal && this.goal.completedGoals ? this.goal.completedGoals : [];
      completedGoals = completedGoals.reverse();
      return completedGoals;
    },
    completedGoalsSteps() {
      let completedGoals = this.goalSteps && this.goalSteps.completedGoals ? this.goalSteps.completedGoals : [];
      completedGoals = completedGoals.reverse();
      return completedGoals;
    },
    formatTotalKm() {
      return this.goal ? formatNumber(this.goal.necessaryDistance, 'км') : '0 км';
    },
    formatTotalKmSteps() {
      return this.goalSteps ? formatNumber(this.goalSteps.necessaryDistance, 'км') : '0 км';
    },
    formatCurrentKm() {
      return this.goal ? formatNumber(this.goal.completedDistance, 'км') : '0 км';
    },
    formatCurrentKmSteps() {
      return this.goalSteps ? formatNumber(this.goalSteps.completedDistance, 'км') : '0 км';
    },
  },
  methods: {
    close() {
      this.selectedTab = 0;
      this.activeTab = this.goal && this.goalSteps && !this.goalSteps.isPrimaryGoalEnabled ? 'Trening' : 'Steps';
      this.$emit('close');
    },
    setActiveTab(tab) {
      this.activeTab = tab;
    },
    onChangeTab(id) {
      this.selectedTab = id;
    },
    formatDate(date) {
      if (!date) return '';
      const value = dayjs.utc(date).local();
      if (value.isValid()) {
        return value.format('DD.MM.YYYY');
      }
      return '';
    },
    getTitle() {
      if (this.type === 'distance') {
        return this.goal ? this.goal.title : '';
      } return this.goal ? this.goal.costTitle : '';
    },
    getSubtitle() {
      if (this.type === 'distance') {
        return this.goal ? this.goal.description : '';
      } return this.goal ? this.goal.costDescription : '';
    },
    replaceVariables(text) {
      if (!text) return '';
      const vars = [
        { id: 'totalKm', value: this.formatTotalKm },
      ];
      let result = text;
      for (let i = 0; i < vars.length; i += 1) {
        result = result.replaceAll(`{{${vars[i].id}}}`, vars[i].value);
      }
      return result;
    },
  },
  mounted() {
    if (this.goal && this.goalSteps && !this.goalSteps.isPrimaryGoalEnabled) {
      this.activeTab = 'Trening';
    } else {
      this.activeTab = 'Steps';
    }
  },
  watch: {
    goalSteps(newGoal) {
      if (newGoal && !newGoal.isPrimaryGoalEnabled) {
        this.activeTab = 'Trening';
      } else {
        this.activeTab = 'Steps';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import './DistanceCharityModal';
</style>
